import React from 'react';
import Text from './Text';
import styles from './FormControls.module.scss';

function FormDescription({
  id,
  children
}) {
  return React.createElement(Text, {
    id: id,
    color: "subtitle",
    variant: "sm",
    className: styles.description
  }, children);
}

export default FormDescription;